"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTeamPlayersGroupDto = instanceOfTeamPlayersGroupDto;
exports.TeamPlayersGroupDtoFromJSON = TeamPlayersGroupDtoFromJSON;
exports.TeamPlayersGroupDtoFromJSONTyped = TeamPlayersGroupDtoFromJSONTyped;
exports.TeamPlayersGroupDtoToJSON = TeamPlayersGroupDtoToJSON;
exports.TeamPlayersGroupDtoToJSONTyped = TeamPlayersGroupDtoToJSONTyped;
var PlayersListDataDto_1 = require("./PlayersListDataDto");
/**
 * Check if a given object implements the TeamPlayersGroupDto interface.
 */
function instanceOfTeamPlayersGroupDto(value) {
    if (!('teamCode' in value) || value['teamCode'] === undefined)
        return false;
    if (!('players' in value) || value['players'] === undefined)
        return false;
    return true;
}
function TeamPlayersGroupDtoFromJSON(json) {
    return TeamPlayersGroupDtoFromJSONTyped(json, false);
}
function TeamPlayersGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'teamCode': json['teamCode'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'players': (json['players'].map(PlayersListDataDto_1.PlayersListDataDtoFromJSON)),
    };
}
function TeamPlayersGroupDtoToJSON(json) {
    return TeamPlayersGroupDtoToJSONTyped(json, false);
}
function TeamPlayersGroupDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'teamCode': value['teamCode'],
        'teamName': value['teamName'],
        'players': (value['players'].map(PlayersListDataDto_1.PlayersListDataDtoToJSON)),
    };
}
